import axios from "axios";
import {
  MARITAL_STATUS_LIST_REQUEST,
  MARITAL_STATUS_LIST_SUCCESS,
  MARITAL_STATUS_LIST_FAIL,
} from "../constants/maritalStatusConstants";
import { api2 } from "../core/api";

export const getMaritalStatus = () => async (dispatch) => {
  try {
    dispatch({
      type: MARITAL_STATUS_LIST_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api2.get("/maritalstatus", config);

    var dt = data.Result;

    if (typeof dt === "string") {
      dispatch({
        type: MARITAL_STATUS_LIST_FAIL,
        payload: dt.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: MARITAL_STATUS_LIST_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: MARITAL_STATUS_LIST_FAIL,
      payload:
        error?.response && error?.response?.data?.message
          ? error?.response?.data?.message
          : error?.message,
    });
  }
};
